export default __webpack_public_path__ + "static/media/18fc18fcf865bdf7.4f0b23f33028b03ac92f41347971abae.svg";